// LoginPage.tsx
import React, { useEffect, useState } from "react";
import logo from "../../../images/Damas_univ.png";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../../Loader";
import { useCookies } from "react-cookie";
import { Bounce, toast, ToastContainer } from "react-toastify";
import { usePOST } from "../../../ApiS";
import Input from "../../Inputs/Input";
import "react-toastify/dist/ReactToastify.css";
import PasswordInput from "../../Inputs/Passwordinput";

const Login: React.FC = () => {
  const notify = (message: string) => {
    toast.error(message, {
      position: "bottom-left",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
    });
  };

  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies(["token"], {
    doNotParse: true,
  });

  const { mutation, handleChangeInput, handleSubmit } = usePOST(
    {
      username: "",
      password: "",
    },
    (data) => {
      setCookie("token", data?.data?.data?.user?.token, { path: "/" });
      navigate("/infomation_application/about");
    },
    () => notify("خطأ في تسجيل الدخول")
  );

  return (
    <div className="flex flex-col items-center justify-center h-[100vh] bg-slate-100   bg-gray-100  ">
      <ToastContainer />

      {mutation.isLoading ? (
        <Loader />
      ) : (
        <div className="bg-white shadow-md rounded-lg px-8 pt-6 pb-8 mb-4 w-[50%] h-[75vh] flex flex-col justify-center max-md:w-[97%]  mx-auto">
          <img
            src={logo}
            alt=""
            className=" lg:w-[250px] md:w-[200px]  max-md:w-[150px] mx-auto"
          />
          <Input
            type="text"
            name="username"
            onChange={handleChangeInput}
            title="اسم المستخدم أو البريد الالكتروني"
            placeholder="أدخل اسم المستخدم أو البريد الألكتروني"
            className="!w-full"
          />
          <div className="mb-6 relative">
            <PasswordInput
              name="password"
              onChange={handleChangeInput}
              title="كلمة السر"
              placeholder="أدخل كلمة المرور"
            />
          </div>
          <div className="flex items-center justify-between">
            <button
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4  focus:outline-none focus:shadow-outline rounded-xl"
              type="submit"
              onClick={() => handleSubmit("admin/login")}
            >
              Sign In
            </button>

            <Link
              to="/forget"
              className="inline-block align-baseline font-bold text-sm text-blue-500 hover:text-blue-800 "
            >
              ? Forget Password
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
